var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 1.75,
    viewBox: "0 0 14 1.75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 0H.875a.875.875 0 000 1.75h12.25a.875.875 0 000-1.75z",
    fill: "#08123b",
    opacity: 0.3
  })));
}

export default SvgMinus;